import axios from 'axios';

export const getSchedule = () => axios({
  url: `${process.env.REACT_APP_API_HOST}/schedule`,
  method: 'GET',
  headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
  }
}).then(response => response.data.data)

export const postSchedule = ({collection, schedule }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/schedule/${collection}`,
    method: 'POST',
    data: schedule,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }, 
}).then(response => response.data.data);

export const putSchedule = ({ collection, _id, schedule }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/schedule/${collection}/${_id}`,
    method: 'PATCH',
    data: schedule,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
}).then(response => response.data.data);

export const deleteSchedule = ({collection, _id }) => axios({
  url: `${process.env.REACT_APP_API_HOST}/schedule/${collection}/${_id}`,
  method: 'DELETE',
  headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
  },
}).then(response => response.data.data);